import { forwardRef, MutableRefObject, useLayoutEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useGSAP } from '@/composables/useGSAP'

import InputRange from './InputRange'

export type QuestionsLikertProps = {
  question: string
  isLeaving: boolean

  value: number
  setValue: (value: number) => void

  index?: number
  max?: number
}

const QuestionsLikertInstruction = forwardRef<HTMLDivElement, QuestionsLikertProps>(
  ({ question, isLeaving, value, setValue, index, max }, ref) => {
    const { t } = useTranslation()
    const { gsap } = useGSAP()

    useLayoutEffect(() => {
      const ctx = gsap.context(() => {
        gsap.timeline().fromTo(
          (ref as MutableRefObject<HTMLDivElement>).current,
          {
            opacity: isLeaving ? 1 : 0,
          },
          {
            opacity: isLeaving ? 0 : 1,
            duration: isLeaving ? 0.3 : 0.5,
            ease: 'power2.out',
            // stagger: {
            //   amount: 0.2,
            //   from: isLeaving ? 'end' : 'start'
            // }
          },
          0
        )
      })

      return () => ctx.kill()
    }, [gsap, ref, isLeaving])

    return (
      <div ref={ref} className='QuestionsLikertInstruction flex flex-col md:justify-end max-md:w-full'>
        <div
          className='FocusStart rounded-12 focus-visible:outline focus-visible:outline-2 outline-scarlet outline-offset-8'
          tabIndex={-1}
        >
          <div className='flex flex-col justify-center gap-8'>
            <h1 className='sr-only'>{t('questions.aria.likert.heading', { step: index, max })}</h1>
            <p className='sr-only'>{t('questions.aria.likert.instruction')}</p>
            <p className='LikertInstruction text-body md:text-body text-center md:px-12 mx-auto'>
              {t('questions.likert.introduction')}
            </p>
            <p className='LikertInstruction text-center md:px-12 mx-auto antialiased font-body font-semibold leading-relaxed text-24 md:text-32'>
              {question}
            </p>
          </div>
          <InputRange currentIndex={value} setCurrentIndex={setValue} />
        </div>
      </div>
    )
  }
)

export default QuestionsLikertInstruction
